import { generateGroupedDateLabels } from '../helpers';

const values = [
  [
    { key: 'followupTasksScheduling', value: '10' },
    { key: 'followupTasksOthers', value: '20' },
  ],
  [
    { key: 'followupTasksScheduling', value: '60' },
    { key: 'followupTasksOthers', value: '140' },
  ],
  [
    { key: 'followupTasksScheduling', value: '70' },
    { key: 'followupTasksOthers', value: '130' },
  ],
  [
    { key: 'followupTasksScheduling', value: '90' },
    { key: 'followupTasksOthers', value: '110' },
  ],
  [
    { key: 'followupTasksScheduling', value: '70' },
    { key: 'followupTasksOthers', value: '100' },
  ],
];

const dateLabels = generateGroupedDateLabels();

export const followUpTasksDummyData = {
  data: dateLabels.map((name, idx) => ({
    name,
    values: values[idx],
  })),
  aggregates: {
    staffAnswered: '0',
    staffUnanswered: '0',
    followupTasksScheduling: '400',
    followupTasksOthers: '500',
  },
};
